"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.number.is-nan");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useFastestValidator;
exports.createValidator = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _fastestValidator = _interopRequireDefault(require("fastest-validator"));

var _invariant = _interopRequireDefault(require("invariant"));

var _libphonenumberJs = require("libphonenumber-js");

var _lodash = _interopRequireDefault(require("lodash.set"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var validationMessages = {
  required: 'sprinxFormsValidation/required',
  string: 'sprinxFormsValidation/string',
  stringEmpty: 'sprinxFormsValidation/stringEmpty',
  stringMin: 'sprinxFormsValidation/stringMin',
  stringMax: 'sprinxFormsValidation/stringMax',
  stringLength: 'sprinxFormsValidation/stringLength',
  stringPattern: 'sprinxFormsValidation/stringPattern',
  stringContains: 'sprinxFormsValidation/stringContains',
  stringEnum: 'sprinxFormsValidation/stringEnum',
  number: 'sprinxFormsValidation/number',
  numberMin: 'sprinxFormsValidation/numberMin',
  numberMax: 'sprinxFormsValidation/numberMax',
  numberEqual: 'sprinxFormsValidation/numberEqual',
  numberNotEqual: 'sprinxFormsValidation/numberNotEqual',
  numberInteger: 'sprinxFormsValidation/numberInteger',
  numberPositive: 'sprinxFormsValidation/numberPositive',
  numberNegative: 'sprinxFormsValidation/numberNegative',
  array: 'sprinxFormsValidation/array',
  arrayEmpty: 'sprinxFormsValidation/arrayEmpty',
  arrayMin: 'sprinxFormsValidation/arrayMin',
  arrayMax: 'sprinxFormsValidation/arrayMax',
  arrayLength: 'sprinxFormsValidation/arrayLength',
  arrayContains: 'sprinxFormsValidation/arrayContains',
  arrayEnum: 'sprinxFormsValidation/arrayEnum',
  boolean: 'sprinxFormsValidation/boolean',
  function: 'sprinxFormsValidation/function',
  date: 'sprinxFormsValidation/date',
  dateMin: 'sprinxFormsValidation/dateMin',
  dateMax: 'sprinxFormsValidation/dateMax',
  forbidden: 'sprinxFormsValidation/forbidden',
  email: 'sprinxFormsValidation/email',
  url: 'sprinxFormsValidation/url',
  object: 'sprinxFormsValidation/object',
  // custom messages
  arrayReducedEquals: 'sprinxFormsValidation/arrayReducedEquals',
  phoneNumber: 'sprinxFormsValidation/phoneNumber',
  dateGt: 'sprinxFormsValidation/dateGt',
  dateGte: 'sprinxFormsValidation/dateGte',
  dateLt: 'sprinxFormsValidation/dateLt',
  dateLte: 'sprinxFormsValidation/dateLte'
};

var createValidator = function createValidator(t) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      messages = _ref.messages,
      rules = _ref.rules;

  _fastestValidator.default.prototype.resolveMessage = function resolveMessage(err) {
    var expected = err.expected != null ? err.expected : '';
    var actual = err.actual != null ? err.actual : '';
    var msg = t(this.messages[err.type], {
      expected: expected,
      actual: actual
    });
    return msg;
  };

  var v = new _fastestValidator.default({
    messages: (0, _extends2.default)({}, validationMessages, {}, messages)
  });
  v.add('date', function date(value, schema
  /* , field, parent */
  ) {
    if (schema.convert === true && !(value instanceof Date)) {
      value = new Date(value);
    }

    if (!(value instanceof Date)) {
      return this.makeError('date');
    }

    if (Number.isNaN(value.getTime())) {
      return this.makeError('date');
    }

    if (schema.min != null && value < schema.min) {
      return this.makeError('dateMin', schema.min, value);
    }

    if (schema.max != null && value > schema.max) {
      return this.makeError('dateMax', schema.max, value);
    }

    return true;
  });
  v.add('arrayReducedEquals', function arrayReducedEquals(value, schema, field, parent) {
    var comparator = schema.comparator,
        reducer = schema.reducer;
    var reduced = reducer(value);
    var res = comparator(parent, reduced);
    return res ? true : this.makeError('arrayReducedEquals', reduced, value);
  });
  v.add('phoneNumber', function phoneNumber(value, schema) {
    var pn = (0, _libphonenumberJs.parsePhoneNumberFromString)(value || '');
    return !value && schema.optional || value && pn && pn.isValid() ? true : this.makeError('phoneNumber', null, value);
  });

  var dateCompare = function dateCompare(op) {
    var dateComppareMap = {
      dateGt: function dateGt(val, ct) {
        return val > ct;
      },
      dateGte: function dateGte(val, ct) {
        return val >= ct;
      },
      dateLt: function dateLt(val, ct) {
        return val < ct;
      },
      dateLte: function dateLte(val, ct) {
        return val <= ct;
      }
    };
    return [op, function (value, schema, field, parent) {
      var compareTo = schema.compareTo,
          convert = schema.convert;

      if (convert === true && !(value instanceof Date)) {
        value = new Date(value);
      }

      var vd = v.rules.date(value, schema);

      if (vd !== true) {
        return vd;
      }

      var ct = typeof compareTo === 'function' ? compareTo(parent) : parent[compareTo];
      var cmpr = dateComppareMap[op];
      (0, _invariant.default)(cmpr, "".concat(op, " is not supported validation rule."));
      return cmpr(value, ct) === true ? true : v.makeError(op);
    }];
  };

  v.add.apply(v, (0, _toConsumableArray2.default)(dateCompare('dateGt')));
  v.add.apply(v, (0, _toConsumableArray2.default)(dateCompare('dateGte')));
  v.add.apply(v, (0, _toConsumableArray2.default)(dateCompare('dateLt')));
  v.add.apply(v, (0, _toConsumableArray2.default)(dateCompare('dateLte')));
  v.add('custom', function customCheckSx(value, schema, field, parent) {
    return schema.check.call(this, value, schema, field, parent);
  });
  (rules || []).forEach(function (_ref2) {
    var _ref3 = (0, _slicedToArray2.default)(_ref2, 3),
        ruleName = _ref3[0],
        callBack = _ref3[1],
        errMsg = _ref3[2];

    v.add(ruleName, callBack);

    if (errMsg) {
      v.messages[ruleName] = errMsg;
    }
  });
  return v;
};

exports.createValidator = createValidator;

var fastestValidator = function fastestValidator(t, schema, options) {
  var vld = createValidator(t, options);
  var check = vld.compile(schema);
  return function (values) {
    var errors = {};

    try {
      var valRes = check(values);
      errors = Array.isArray(valRes) ? valRes.reduce(function (a, e) {
        return (0, _lodash.default)(a, e.field, e.message);
      }, {}) : {};
    } catch (e) {
      console.error('Validation call error', e); // eslint-disable-line no-console
    }

    return errors;
  };
};

function useFastestValidator() {
  var t = (0, _useTranslate.default)();
  return _react.default.useCallback(function (schema, options) {
    return fastestValidator(t, schema, options);
  }, [t]);
}